export const environment = {
  production: true,
  // TODO - Will remove after v3 release
  // firebaseConfig: {
  //   apiKey: "AIzaSyA03T0-Jw8WsUy5FlQy1y1BSgX4XzUjUwU",
  //   authDomain: "rmcrm-da053.firebaseapp.com",
  //   databaseURL: 'https://rmcrm-da053-default-rtdb.asia-southeast1.firebasedatabase.app',
  //   projectId: "rmcrm-da053",
  //   storageBucket: "rmcrm-da053.appspot.com",
  //   messagingSenderId: "444883318825",
  //   appId: "1:444883318825:web:fcce517b7d5397bf898438",
  //   measurementId: "G-ZNYCMH30QN",
  // },
  firebaseConfig: {
    apiKey: "AIzaSyDGqlwkGKdTh5A19FHsRkSzz5-SDpZe9Ac",
    authDomain: "tripmeld-dev-42d09.firebaseapp.com",
    databaseURL: "https://tripmeld-dev-42d09-default-rtdb.asia-southeast1.firebasedatabase.app/",
    projectId: "tripmeld-dev-42d09",
    storageBucket: "tripmeld-dev-42d09.firebasestorage.app",
    messagingSenderId: "497755010845",
    appId: "1:497755010845:web:e2f08e0fefc8cabccc93f4",
    measurementId: "G-T6FVCQ2QC5"
  },
  integration: 'https://tripmeldcrm-dev-integration.azurewebsites.net/api/integration',
  travel: 'https://tripmeldcrm-dev-travel.azurewebsites.net/api/travel',
  common: 'https://tripmeldcrm-dev-common.azurewebsites.net/api/common',
  inventory: 'https://tripmeldcrm-dev-inventory.azurewebsites.net/api/inventory',
  calltracker: "https://tripmeldcrm-dev-calltracker.azurewebsites.net/api/calltracker",
  pdf: 'https://tripmeldcrm-dev-pdf.azurewebsites.net/api/pdf',
  chat: "https://tripmeldcrm-dev-chat.azurewebsites.net/api/chat",
  administration: "https://tripmeldcrm-dev-administration.azurewebsites.net/api/administration",
  dmc: "https://tripmeldcrm-dev-dmc.azurewebsites.net/api/dmcs",
  payments: "https://tripmeldcrm-dev-payments.azurewebsites.net/api/payments",
  websitebuilder: "https://tripmeldcrm-dev-websitebuilder.azurewebsites.net/api/websitebuilder",
  whatsapp: "https://tripmeldcrm-dev-whatsapp.azurewebsites.net/api/whatsapp"
};
